import React from "react";

import {statusChange, priceChange} from "domain/enum/lineItem/lineItemActivityType";

import AssignedLog from "./AssignedLog";
import PriceChangeLog from "./PriceChangeLog";
import StatusChangeLog from "./StatusChangeLog";
import ActionLog from "./ActionLog";

export default function CenterText({item, order, userName, isNote, type}) {
    if (isNote) {
        const commandRegex = /Je me suis affecté la commande: #(.*)/g;
        if (commandRegex.exec(item.content)) {
            return <AssignedLog order={order} userName={userName} />;
        }
        return <ActionLog order={order} />;
    }

    if (type === priceChange) {
        return <PriceChangeLog item={item} />;
    } else if (type === statusChange) {
        return <StatusChangeLog item={item} />;
    }

    return <ActionLog order={order} />;
}
